var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.65,
    width: 76.0678,
    height: 76.0678,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8205 31.6112C45.8205 35.7832 42.4754 39.1285 38.3004 39.1285C34.1268 39.1285 30.7803 35.7832 30.7803 31.6112C30.7803 27.4391 34.1268 24.0952 38.3004 24.0952C42.4754 24.0952 45.8205 27.4391 45.8205 31.6112ZM38.3004 52.5052C32.1388 52.5052 26.9364 51.5038 26.9364 47.64C26.9364 43.7747 32.1715 42.8088 38.3004 42.8088C44.4634 42.8088 49.6644 43.8103 49.6644 47.6741C49.6644 51.5393 44.4293 52.5052 38.3004 52.5052Z",
    fill: "#67CE67"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenAvatar);
export default __webpack_public_path__ + "static/media/green-avatar.9d4725cae9cd6a40ae04d5667423826a.svg";
export { ForwardRef as ReactComponent };